import { cva } from '@/styled-system/css';

export const propertyCardSaveButtonRecipe = cva({
  base: {
    // Use padding to extend to size of a large icon button.
    // It's ok that icon is not exactly in center of button.
    // Consult with SRP teams before changing the hit area as this could affect metrics.
    'padding': `{spacing.PropertyCard.SaveButton.padding.top} {spacing.PropertyCard.SaveButton.padding.right} {spacing.PropertyCard.SaveButton.padding.bottom} {spacing.PropertyCard.SaveButton.padding.left}`,
    'transition': 'box-shadow 200ms ease',
    '& > [data-c11n-component="PropertyCard.SaveButtonIcon"]': {
      // Can't use our core box shadow tokens because drop-shadow doesn't accept spread-radius
      filter: 'drop-shadow(rgba(0, 0, 0, 0.3) 0px 2px 4px)',
      blockSize: 'PropertyCard.SaveButton.height',
      inlineSize: 'PropertyCard.SaveButton.width',
    },

    '& .c11n-property-card-heartIcon-outline': {
      fill: 'PropertyCard.SaveButton.border.default',
    },

    '& .c11n-property-card-heartIcon-fill': {
      fill: 'PropertyCard.SaveButton.bg.default',
    },

    '_hover': {
      'cursor': 'pointer',

      '& .c11n-property-card-heartIcon-outline': {
        fill: 'PropertyCard.SaveButton.border.hover',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'PropertyCard.SaveButton.bg.hover',
      },
    },

    '_active': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'PropertyCard.SaveButton.border.pressed',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'PropertyCard.SaveButton.bg.pressed',
      },
    },

    '_focus': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'PropertyCard.SaveButton.border.pressed',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'PropertyCard.SaveButton.bg.pressed',
      },
    },

    '_focusVisible': {
      boxShadow: 'focus',
    },

    // aria-label selector added for SEO test (CDS-1992)
    '&&[aria-pressed="true"], &&[aria-label="Unsave"]': {
      '& .c11n-property-card-heartIcon-outline': {
        fill: 'PropertyCard.SaveButton.border.selected',
      },

      '& .c11n-property-card-heartIcon-fill': {
        fill: 'PropertyCard.SaveButton.bg.selected',
      },

      '_hover': {
        '& .c11n-property-card-heartIcon-outline': {
          fill: 'PropertyCard.SaveButton.border.selectedHover',
        },

        '& .c11n-property-card-heartIcon-fill': {
          fill: 'PropertyCard.SaveButton.bg.selectedHover',
        },
      },

      '_active': {
        '& .c11n-property-card-heartIcon-outline': {
          fill: 'PropertyCard.SaveButton.border.selectedPressed',
        },

        '& .c11n-property-card-heartIcon-fill': {
          fill: 'PropertyCard.SaveButton.bg.selectedPressed',
        },
      },
    },
  },
});
